export const ChainlinkAbi = [
  {
    type: "function",
    name: "latestRoundData",
    inputs: [],
    outputs: [
      {
        name: "roundId",
        type: "uint80",
        internalType: "uint80",
      },
      {
        name: "answer",
        type: "int256",
        internalType: "int256",
      },
      {
        name: "startedAt",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "updatedAt",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "answeredInRound",
        type: "uint80",
        internalType: "uint80",
      },
    ],
    stateMutability: "view",
  },
];
